function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".hero_svg__st2{opacity:.8}.hero_svg__st4{opacity:.7}.hero_svg__st6{opacity:.6}.hero_svg__st8{opacity:.3}.hero_svg__st10{opacity:.1}.hero_svg__st37{fill:none}.hero_svg__st40{fill:#00937f}.hero_svg__st49{fill:#fff}.hero_svg__st50{opacity:.7;fill:#00937f}.hero_svg__st140{fill:#00434f}.hero_svg__st146{fill:#005157}.hero_svg__st156{fill:#cc5693}.hero_svg__st157{fill:#ff73b0}.hero_svg__st158{fill:#00665f}");

var _ref2 = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.5
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 236.245,
  y1: 615.028,
  x2: 409.48,
  y2: 314.976
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_1_)",
  d: "M151 565.8l-1-1.7 344.7-199.9 1 1.7z"
}), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st2"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 266.253,
  y1: 632.532,
  x2: 439.488,
  y2: 332.48
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_2_)",
  d: "M181 583.3l-1-1.7 344.7-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st4"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 296.26,
  y1: 650.037,
  x2: 469.495,
  y2: 349.984
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_3_)",
  d: "M211.1 600.8l-1-1.7 344.6-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st6"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_4_",
  gradientUnits: "userSpaceOnUse",
  x1: 326.267,
  y1: 667.541,
  x2: 499.503,
  y2: 367.488
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_4_)",
  d: "M241.1 618.3l-1-1.7 344.6-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st8"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_5_",
  gradientUnits: "userSpaceOnUse",
  x1: 356.275,
  y1: 685.046,
  x2: 529.511,
  y2: 384.993
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_5_)",
  d: "M271.1 635.9l-1-1.8 344.6-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st10"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_6_",
  gradientUnits: "userSpaceOnUse",
  x1: 386.283,
  y1: 702.55,
  x2: 559.518,
  y2: 402.497
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_6_)",
  d: "M301.1 653.4l-1-1.8 344.6-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st10"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_7_",
  gradientUnits: "userSpaceOnUse",
  x1: 86.207,
  y1: 527.506,
  x2: 259.442,
  y2: 227.453
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_7_)",
  d: "M1 478.3l-1-1.7 344.6-200 1.1 1.8z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st8"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_8_",
  gradientUnits: "userSpaceOnUse",
  x1: 116.215,
  y1: 545.01,
  x2: 289.45,
  y2: 244.958
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_8_)",
  d: "M31 495.8l-1-1.7 344.7-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st6"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_9_",
  gradientUnits: "userSpaceOnUse",
  x1: 146.222,
  y1: 562.515,
  x2: 319.458,
  y2: 262.462
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_9_)",
  d: "M61 513.3l-1-1.7 344.7-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st4"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_10_",
  gradientUnits: "userSpaceOnUse",
  x1: 176.23,
  y1: 580.019,
  x2: 349.465,
  y2: 279.967
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_10_)",
  d: "M91 530.8l-1-1.7 344.7-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st2"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_11_",
  gradientUnits: "userSpaceOnUse",
  x1: 206.238,
  y1: 597.523,
  x2: 379.473,
  y2: 297.471
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_11_)",
  d: "M121 548.3l-1-1.7 344.7-199.9 1 1.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st10"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_12_",
  gradientUnits: "userSpaceOnUse",
  x1: 2987.619,
  y1: 527.506,
  x2: 3160.854,
  y2: 227.453,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_12_)",
  d: "M644.7 478.3L300.1 278.4l1-1.8 344.6 200z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st8"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_13_",
  gradientUnits: "userSpaceOnUse",
  x1: 3017.626,
  y1: 545.01,
  x2: 3190.861,
  y2: 244.958,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_13_)",
  d: "M614.7 495.8L270.1 295.9l1-1.7 344.6 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st6"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_14_",
  gradientUnits: "userSpaceOnUse",
  x1: 3047.634,
  y1: 562.515,
  x2: 3220.87,
  y2: 262.462,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_14_)",
  d: "M584.7 513.3L240.1 313.4l1-1.7 344.6 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st4"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_15_",
  gradientUnits: "userSpaceOnUse",
  x1: 3077.642,
  y1: 580.019,
  x2: 3250.877,
  y2: 279.967,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_15_)",
  d: "M554.7 530.8L210.1 330.9l1-1.7 344.6 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st2"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_16_",
  gradientUnits: "userSpaceOnUse",
  x1: 3107.649,
  y1: 597.523,
  x2: 3280.884,
  y2: 297.471,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_16_)",
  d: "M524.7 548.3L180 348.4l1-1.7 344.7 199.9z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_17_",
  gradientUnits: "userSpaceOnUse",
  x1: 3137.657,
  y1: 615.028,
  x2: 3310.892,
  y2: 314.976,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_17_)",
  d: "M494.7 565.8L150 365.9l1-1.7 344.7 199.9z"
}), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st2"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_18_",
  gradientUnits: "userSpaceOnUse",
  x1: 3167.664,
  y1: 632.532,
  x2: 3340.899,
  y2: 332.48,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_18_)",
  d: "M464.7 583.3L120 383.4l1-1.7 344.7 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st4"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_19_",
  gradientUnits: "userSpaceOnUse",
  x1: 3197.672,
  y1: 650.037,
  x2: 3370.907,
  y2: 349.984,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_19_)",
  d: "M434.7 600.8L90 400.9l1-1.7 344.7 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st6"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_20_",
  gradientUnits: "userSpaceOnUse",
  x1: 3227.679,
  y1: 667.541,
  x2: 3400.915,
  y2: 367.488,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_20_)",
  d: "M404.7 618.3L60 418.4l1-1.7 344.7 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st8"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_21_",
  gradientUnits: "userSpaceOnUse",
  x1: 3257.687,
  y1: 685.046,
  x2: 3430.922,
  y2: 384.993,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_21_)",
  d: "M374.7 635.9L30 435.9l1-1.7 344.7 199.9z"
})), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st10"
}, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_22_",
  gradientUnits: "userSpaceOnUse",
  x1: 3287.694,
  y1: 702.55,
  x2: 3460.93,
  y2: 402.497,
  gradientTransform: "matrix(-1 0 0 1 3547.137 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.482,
  stopColor: "#7affbf",
  stopOpacity: 0.678
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf",
  stopOpacity: 0.7
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_22_)",
  d: "M344.6 653.4L0 453.4l1-1.7 344.7 199.9z"
}))), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_23_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.442,
  y1: 573.768,
  x2: 357.246,
  y2: 573.768
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006b6b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M291 576.5l28.9 16.7c2.1 1.2 4.7 1.2 6.8 0l28.9-16.7c2.1-1.2 2.1-4.3 0-5.6l-28.9-16.7c-2.1-1.2-4.7-1.2-6.8 0L291 571c-2.1 1.2-2.1 4.3 0 5.5z",
  fill: "url(#hero_svg__SVGID_23_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_24_",
  gradientUnits: "userSpaceOnUse",
  x1: 347.943,
  y1: 539.804,
  x2: 415.748,
  y2: 539.804
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006b6b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M349.5 542.6l28.9 16.7c2.1 1.2 4.7 1.2 6.8 0l28.9-16.7c2.1-1.2 2.1-4.3 0-5.6l-28.9-16.7c-2.1-1.2-4.7-1.2-6.8 0L349.5 537c-2.1 1.3-2.1 4.3 0 5.6z",
  fill: "url(#hero_svg__SVGID_24_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_25_",
  gradientUnits: "userSpaceOnUse",
  x1: 406.382,
  y1: 505.229,
  x2: 474.187,
  y2: 505.229
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006b6b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M408 508l28.9 16.7c2.1 1.2 4.7 1.2 6.8 0l28.9-16.7c2.1-1.2 2.1-4.3 0-5.6l-28.9-16.7c-2.1-1.2-4.7-1.2-6.8 0L408 502.4c-2.2 1.3-2.2 4.4 0 5.6z",
  fill: "url(#hero_svg__SVGID_25_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_26_",
  gradientUnits: "userSpaceOnUse",
  x1: 466.765,
  y1: 470.601,
  x2: 534.57,
  y2: 470.601
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#006b6b",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M468.4 473.4l28.9 16.7c2.1 1.2 4.7 1.2 6.8 0l28.9-16.7c2.1-1.2 2.1-4.3 0-5.6l-28.9-16.7c-2.1-1.2-4.7-1.2-6.8 0l-28.9 16.7c-2.2 1.3-2.2 4.3 0 5.6z",
  fill: "url(#hero_svg__SVGID_26_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_27_",
  gradientUnits: "userSpaceOnUse",
  x1: -27.884,
  y1: 330.934,
  x2: -148.86,
  y2: 397.918,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00665f",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f",
  stopOpacity: 0.6
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_27_)",
  d: "M206.3 401.3l43.4-58.1-132.1-26.3-49.7 60.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_28_",
  gradientUnits: "userSpaceOnUse",
  x1: -194.817,
  y1: 302.457,
  x2: -87.251,
  y2: 302.457,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M164.7 363.7V244.9l71.2-41.3v132.8l36.3 20.6-66.4 44.4-29.2-16.9c-7.3-4.3-11.9-12.3-11.9-20.8z",
  fill: "url(#hero_svg__SVGID_28_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_29_",
  gradientUnits: "userSpaceOnUse",
  x1: -184.957,
  y1: 380.892,
  x2: -103.287,
  y2: 243.686,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M169.7 363.1V242.3l71.2-41.3v121c0 7.3 3.9 14.1 10.3 17.7l26 14.7-71.4 41.2-25.9-14.8c-6.3-3.6-10.2-10.4-10.2-17.7z",
  fill: "url(#hero_svg__SVGID_29_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_30_",
  gradientUnits: "userSpaceOnUse",
  x1: -235.914,
  y1: 337.479,
  x2: 9.637,
  y2: 475.472,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_30_)",
  d: "M277.2 354.3v5.9l-71.3 41.2v-5.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_31_",
  gradientUnits: "userSpaceOnUse",
  x1: -199.962,
  y1: 319.205,
  x2: -91.715,
  y2: 319.205,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.448,
  stopColor: "#fff",
  stopOpacity: 0.8
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.962,
  stopColor: "#fff",
  stopOpacity: 0.148
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  d: "M205.8 396.1l-26.1-14.9c-6.5-3.7-10.5-10.6-10.5-18.1V242.3h.9v120.8c0 7.1 3.8 13.8 10 17.3l25.6 14.6 71.3-41 .5.8-71.7 41.3z",
  fill: "url(#hero_svg__SVGID_31_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M56.2 387.9l7.4 4.3-7.4-4.3zm14.4 4.4l144-83.2-144 83.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_32_",
  gradientUnits: "userSpaceOnUse",
  x1: -336.078,
  y1: -40.061,
  x2: 255.206,
  y2: 288.631,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M71.8 160.4L331.7 10.1c2.2-1.3 4.9.3 4.9 2.8v-1.6c0-2.5-1.3-4.8-3.5-6L325.6 1c-2.1-1.2-4.8-1.2-7 0L56.2 152.5c-1.1.6-1.9 1.5-2.5 2.5l15 8.5c.7-1.3 1.8-2.3 3.1-3.1z",
  fill: "url(#hero_svg__SVGID_32_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_33_",
  gradientUnits: "userSpaceOnUse",
  x1: 16.855,
  y1: 124.983,
  x2: 16.855,
  y2: 551.851,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.1 349.9V168.5c0-1.8.5-3.6 1.5-5.1l-15-8.5c-.6 1-.9 2.2-.9 3.5v223.4c0 2.5 1.3 4.8 3.5 6l7.5 4.3c1.1.6 2.3.9 3.5.9v-43.1z",
  fill: "url(#hero_svg__SVGID_33_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M82.4 171.3L70.3 348l266.3-154V21z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M331.7 10.1L71.8 160.4c-1.3.8-2.4 1.8-3.2 3.1l13.9 7.8L336.6 21v-8.1c0-2.5-2.8-4.1-4.9-2.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M67.1 168.5v181.3l3.2-1.8 12.2-176.7-13.9-7.8c-1 1.5-1.5 3.2-1.5 5z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_34_",
  gradientUnits: "userSpaceOnUse",
  x1: 73.112,
  y1: 343.619,
  x2: 844.787,
  y2: -639.347
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M331.7 10.1L71.8 160.4c-1.3.8-2.4 1.8-3.2 3.1-.9 1.5-1.5 3.2-1.5 5.1v181.3l3.2-1.8 266.3-154V12.9c0-2.5-2.8-4.1-4.9-2.8z",
  fill: "url(#hero_svg__SVGID_34_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_35_",
  gradientUnits: "userSpaceOnUse",
  x1: 8.822,
  y1: 124.983,
  x2: 8.822,
  y2: 551.851,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.1 350.2v42.9h.1l3.1-44.8-3.2 1.9z",
  fill: "url(#hero_svg__SVGID_35_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_36_",
  gradientUnits: "userSpaceOnUse",
  x1: -2809.244,
  y1: -1398.204,
  x2: 4158.631,
  y2: 2517.558
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M70.3 348.4l-3.2 1.8v42.9h.1c1.2 0 2.4-.3 3.4-.9l144-83.1 118.5-68.4c2.1-1.2 3.5-3.5 3.5-6v-40L70.3 348.4z",
  fill: "url(#hero_svg__SVGID_36_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M70.3 348.4l266.3-153.7v-.7L70.3 348z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_37_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.207,
  y1: 383.717,
  x2: 382.566,
  y2: 43.152
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_37_)",
  d: "M70.3 348.4l266.3-153.7v-.7L70.3 348z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_38_",
  gradientUnits: "userSpaceOnUse",
  x1: -395.66,
  y1: 119.629,
  x2: 564.011,
  y2: 658.939,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_38_)",
  d: "M70.3 348.4l266.3-153.7v-.7L70.3 348z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M67.1 350.2l3.2-1.8v-.4l-3.2 1.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_39_",
  gradientUnits: "userSpaceOnUse",
  x1: 69.57,
  y1: 348.004,
  x2: 336.93,
  y2: 7.439
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_39_)",
  d: "M67.1 350.2l3.2-1.8v-.4l-3.2 1.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_40_",
  gradientUnits: "userSpaceOnUse",
  x1: -396.602,
  y1: 121.305,
  x2: 563.07,
  y2: 660.614,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_40_)",
  d: "M67.1 350.2l3.2-1.8v-.4l-3.2 1.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M301.8 69.5L103.5 184.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_41_",
  gradientUnits: "userSpaceOnUse",
  x1: 344.322,
  y1: 556.576,
  x2: 152.429,
  y2: 168.077
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0.5
})), /*#__PURE__*/React.createElement("path", {
  d: "M100.1 457.7c0 11 5.9 21.2 15.4 26.8l171.4 100c2.1 1.2 4.7 1.2 6.9 0l197.9-115c2.3-1.3 2.3-4.7 0-6.1L322.4 365c-9.5-5.6-15.4-15.8-15.4-26.8V78.3L100.1 197.7v260z",
  fill: "url(#hero_svg__SVGID_41_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M100.1 190v7.7L307 78.3v-5.8c0-2.7-2.9-4.4-5.3-3L103.5 184.1c-2.1 1.2-3.4 3.5-3.4 5.9zm21.6-12.8c1.1-.3 1.9.3 1.9 1.3s-.9 2.2-1.9 2.5-1.9-.3-1.9-1.3.9-2.2 1.9-2.5zm-7.3 4.5c1.1-.3 1.9.3 1.9 1.3s-.9 2.2-1.9 2.5-1.9-.3-1.9-1.3.8-2.2 1.9-2.5zm-7.4 4.4c1.1-.3 1.9.3 1.9 1.3 0 1.1-.9 2.2-1.9 2.5-1.1.3-1.9-.3-1.9-1.3 0-1.1.9-2.2 1.9-2.5z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M107 189.9c1.1-.3 1.9-1.4 1.9-2.5s-.9-1.7-1.9-1.3-1.9 1.4-1.9 2.5c0 1 .9 1.6 1.9 1.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st50",
  d: "M107 189.9c1.1-.3 1.9-1.4 1.9-2.5s-.9-1.7-1.9-1.3-1.9 1.4-1.9 2.5c0 1 .9 1.6 1.9 1.3z"
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-49.286 114.392 183.563)",
  className: "hero_svg__st49",
  cx: 114.4,
  cy: 183.6,
  rx: 2.2,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-49.286 114.392 183.563)",
  className: "hero_svg__st50",
  cx: 114.4,
  cy: 183.6,
  rx: 2.2,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-49.286 121.743 179.125)",
  className: "hero_svg__st49",
  cx: 121.7,
  cy: 179.1,
  rx: 2.2,
  ry: 1.6
}), /*#__PURE__*/React.createElement("ellipse", {
  transform: "rotate(-49.286 121.743 179.125)",
  className: "hero_svg__st50",
  cx: 121.7,
  cy: 179.1,
  rx: 2.2,
  ry: 1.6
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_42_",
  gradientUnits: "userSpaceOnUse",
  x1: -259.356,
  y1: 271.933,
  x2: 10.703,
  y2: 271.933,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.965,
  stopColor: "#fff",
  stopOpacity: 0.162
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_42_)",
  d: "M67.4 350.4l-.6-1.1 269.4-155.8.7 1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_43_",
  gradientUnits: "userSpaceOnUse",
  x1: 507.503,
  y1: 418.244,
  x2: 475.665,
  y2: 355.365
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_43_)",
  d: "M500.7 424.4V298.9L467 318.3v125.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_44_",
  gradientUnits: "userSpaceOnUse",
  x1: 507.378,
  y1: 426.658,
  x2: 525.245,
  y2: 389.984
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_44_)",
  d: "M500.7 424.4v-56.7l33.6 19.4v57.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M496.4 478.7l-12.4-7.1zm0-53.6l-12.4 7.1 12.4-7.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_45_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.556,
  y1: -3058.902,
  x2: 237.905,
  y2: -3058.902,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3l2.4-1.4c-2.3.6-4.8.3-7-.9l-27.9-16.4c-.7 1.3-1.2 2.8-1.2 4.4v9.8c0 3.1 1.7 6 4.4 7.6l12.5 7.2 12.5 7.2c1.1.7 2.4 1 3.6 1.1v-18.6h.7z",
  fill: "url(#hero_svg__SVGID_45_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_46_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.557,
  y1: -3058.902,
  x2: 237.906,
  y2: -3058.902,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M505.4 459c-.7.4-1.4.7-2.2.9l-2.4 1.4h.7v18.6c1.3-.1 2.5-.5 3.6-1.1l24.9-14.4c2.7-1.6 4.4-4.4 4.4-7.6V447c0-1.6-.4-3.1-1.2-4.4L505.4 459z",
  fill: "url(#hero_svg__SVGID_46_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_47_",
  gradientUnits: "userSpaceOnUse",
  x1: 226.013,
  y1: -3038.893,
  x2: 226.013,
  y2: -3075.318,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M505.4 459c-.7.4-1.4.7-2.2.9l-2.4 1.4h.7v18.6c1.3-.1 2.5-.5 3.6-1.1l24.9-14.4c2.7-1.6 4.4-4.4 4.4-7.6V447c0-1.6-.4-3.1-1.2-4.4L505.4 459z",
  fill: "url(#hero_svg__SVGID_47_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_48_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.556,
  y1: -3049.543,
  x2: 237.905,
  y2: -3049.543,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3h-.7v18.6h.7v-18.6z",
  fill: "url(#hero_svg__SVGID_48_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_49_",
  gradientUnits: "userSpaceOnUse",
  x1: 500.43,
  y1: 481.262,
  x2: 500.43,
  y2: 461.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3h-.7v18.6h.7v-18.6z",
  fill: "url(#hero_svg__SVGID_49_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_50_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.556,
  y1: -3049.543,
  x2: 237.905,
  y2: -3049.543,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3v18.6h.7v-18.6h-.7z",
  fill: "url(#hero_svg__SVGID_50_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_51_",
  gradientUnits: "userSpaceOnUse",
  x1: 209.56,
  y1: -3038.893,
  x2: 209.56,
  y2: -3075.318,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3v18.6h.7v-18.6h-.7z",
  fill: "url(#hero_svg__SVGID_51_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_52_",
  gradientUnits: "userSpaceOnUse",
  x1: 501.161,
  y1: 481.262,
  x2: 501.161,
  y2: 461.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461.3v18.6h.7v-18.6h-.7z",
  fill: "url(#hero_svg__SVGID_52_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_53_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.556,
  y1: -3078.082,
  x2: 237.905,
  y2: -3078.082,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M503.2 459.9l30.1-17.3c-.8-1.3-1.8-2.4-3.2-3.2L505.2 425c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c2.2 1.3 4.7 1.6 7 .9z",
  fill: "url(#hero_svg__SVGID_53_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_54_",
  gradientUnits: "userSpaceOnUse",
  x1: 500.793,
  y1: 421.993,
  x2: 500.793,
  y2: 480.514
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M503.2 459.9l30.1-17.3c-.8-1.3-1.8-2.4-3.2-3.2L505.2 425c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c2.2 1.3 4.7 1.6 7 .9z",
  fill: "url(#hero_svg__SVGID_54_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_55_",
  gradientUnits: "userSpaceOnUse",
  x1: 175.556,
  y1: -3068.874,
  x2: 237.905,
  y2: -3068.874,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M505.4 459l27.9-16.4-30.1 17.3c.7-.2 1.5-.5 2.2-.9z",
  fill: "url(#hero_svg__SVGID_55_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_56_",
  gradientUnits: "userSpaceOnUse",
  x1: 226.632,
  y1: -3038.893,
  x2: 226.632,
  y2: -3075.318,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M505.4 459l27.9-16.4-30.1 17.3c.7-.2 1.5-.5 2.2-.9z",
  fill: "url(#hero_svg__SVGID_56_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_57_",
  gradientUnits: "userSpaceOnUse",
  x1: 518.234,
  y1: 421.993,
  x2: 518.234,
  y2: 480.514
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M505.4 459l27.9-16.4-30.1 17.3c.7-.2 1.5-.5 2.2-.9z",
  fill: "url(#hero_svg__SVGID_57_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_58_",
  gradientUnits: "userSpaceOnUse",
  x1: 466.905,
  y1: 451.348,
  x2: 534.686,
  y2: 451.348
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M500.8 461c-1.9 0-3.9-.5-5.6-1.5l-28.3-16.6.7-1.3 28.3 16.6c3 1.8 6.7 1.8 9.7 0l28.3-16.6.7 1.3-28.3 16.6c-1.6 1-3.6 1.5-5.5 1.5z",
  fill: "url(#hero_svg__SVGID_58_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_59_",
  gradientUnits: "userSpaceOnUse",
  x1: 441.638,
  y1: 393.456,
  x2: 410.107,
  y2: 331.183
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_59_)",
  d: "M440.3 395.6v-95.8l-33.6 19.4v96.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_60_",
  gradientUnits: "userSpaceOnUse",
  x1: 447.3,
  y1: 398.109,
  x2: 467.804,
  y2: 356.023
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_60_)",
  d: "M440.3 395.6v-55l33.6 19.4v55.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M444.7 397.2l12.4 7.2zm0 116.1l12.4-7.2-12.4 7.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_61_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3055.528,
  x2: 177.4,
  y2: -3055.528,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 433.1l1.6-.9c-2.1.4-4.3 0-6.2-1.1l-27.8-16.3c-.7 1.3-1.2 2.8-1.2 4.4v72.2c0 3.1 1.7 6 4.4 7.6l24.9 14.4c1.1.7 2.4 1 3.6 1.1v-81.3h.7z",
  fill: "url(#hero_svg__SVGID_61_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_62_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3055.528,
  x2: 177.4,
  y2: -3055.528,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M445 431.1c-1 .6-2 .9-3.1 1.1l-1.6.9h.7v81.3c1.3-.1 2.5-.5 3.6-1.1l12.5-7.2 12.5-7.2c2.7-1.6 4.4-4.4 4.4-7.6v-72.2c0-1.6-.4-3.1-1.2-4.4L445 431.1z",
  fill: "url(#hero_svg__SVGID_62_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_63_",
  gradientUnits: "userSpaceOnUse",
  x1: 165.508,
  y1: -3004.31,
  x2: 165.508,
  y2: -3098.582,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M445 431.1c-1 .6-2 .9-3.1 1.1l-1.6.9h.7v81.3c1.3-.1 2.5-.5 3.6-1.1l12.5-7.2 12.5-7.2c2.7-1.6 4.4-4.4 4.4-7.6v-72.2c0-1.6-.4-3.1-1.2-4.4L445 431.1z",
  fill: "url(#hero_svg__SVGID_63_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_64_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3046.348,
  x2: 177.4,
  y2: -3046.348,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M439.6 433.1v81.3h.7V433h-.7z",
  fill: "url(#hero_svg__SVGID_64_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_65_",
  gradientUnits: "userSpaceOnUse",
  x1: 439.925,
  y1: 515.845,
  x2: 439.925,
  y2: 433.118
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M439.6 433.1v81.3h.7V433h-.7z",
  fill: "url(#hero_svg__SVGID_65_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_66_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3046.348,
  x2: 177.4,
  y2: -3046.348,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 433.1v81.4h.7v-81.3h-.7z",
  fill: "url(#hero_svg__SVGID_66_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_67_",
  gradientUnits: "userSpaceOnUse",
  x1: 149.055,
  y1: -3004.31,
  x2: 149.055,
  y2: -3098.582,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 433.1v81.4h.7v-81.3h-.7z",
  fill: "url(#hero_svg__SVGID_67_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_68_",
  gradientUnits: "userSpaceOnUse",
  x1: 440.656,
  y1: 515.845,
  x2: 440.656,
  y2: 433.118
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 433.1v81.4h.7v-81.3h-.7z",
  fill: "url(#hero_svg__SVGID_68_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_69_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3105.941,
  x2: 177.4,
  y2: -3105.941,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M441.8 432.2l30.9-17.5c-.8-1.3-1.8-2.4-3.2-3.2l-12.5-7.2-12.5-7.2c-2.7-1.6-6-1.6-8.7 0L411 411.6c-1.4.8-2.4 1.9-3.2 3.2l27.8 16.3c1.9 1.1 4.1 1.5 6.2 1.1z",
  fill: "url(#hero_svg__SVGID_69_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_70_",
  gradientUnits: "userSpaceOnUse",
  x1: 440.285,
  y1: 394.993,
  x2: 440.285,
  y2: 456.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M441.8 432.2l30.9-17.5c-.8-1.3-1.8-2.4-3.2-3.2l-12.5-7.2-12.5-7.2c-2.7-1.6-6-1.6-8.7 0L411 411.6c-1.4.8-2.4 1.9-3.2 3.2l27.8 16.3c1.9 1.1 4.1 1.5 6.2 1.1z",
  fill: "url(#hero_svg__SVGID_70_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_71_",
  gradientUnits: "userSpaceOnUse",
  x1: 115.051,
  y1: -3096.641,
  x2: 177.4,
  y2: -3096.641,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M445 431.1l27.8-16.3-30.9 17.5c1-.2 2.1-.6 3.1-1.2z",
  fill: "url(#hero_svg__SVGID_71_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_72_",
  gradientUnits: "userSpaceOnUse",
  x1: 165.703,
  y1: -3004.31,
  x2: 165.703,
  y2: -3098.582,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M445 431.1l27.8-16.3-30.9 17.5c1-.2 2.1-.6 3.1-1.2z",
  fill: "url(#hero_svg__SVGID_72_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_73_",
  gradientUnits: "userSpaceOnUse",
  x1: 457.304,
  y1: 394.993,
  x2: 457.304,
  y2: 456.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M445 431.1l27.8-16.3-30.9 17.5c1-.2 2.1-.6 3.1-1.2z",
  fill: "url(#hero_svg__SVGID_73_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_74_",
  gradientUnits: "userSpaceOnUse",
  x1: 406.4,
  y1: 423.522,
  x2: 474.181,
  y2: 423.522
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 433.2c-2 0-3.9-.5-5.7-1.5l-28.2-16.6.7-1.3 28.2 16.6c3 1.8 6.8 1.8 9.8 0l28.2-16.6.7 1.3-28.2 16.6c-1.6 1-3.6 1.5-5.5 1.5z",
  fill: "url(#hero_svg__SVGID_74_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_75_",
  gradientUnits: "userSpaceOnUse",
  x1: 380.296,
  y1: 354.778,
  x2: 352.838,
  y2: 300.55
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_75_)",
  d: "M381.8 354.8v-80.1l-33.6 19.4v80.4z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_76_",
  gradientUnits: "userSpaceOnUse",
  x1: 379.381,
  y1: 348.575,
  x2: 415.935,
  y2: 273.543
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_76_)",
  d: "M381.8 354.8V243.5l33.7 19.4v111.6z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M352.6 532.6l12.4 7.2-12.4-7.2zm0-161.9l12.4-7.2zM386.2 547l24.9-14.4-24.9 14.4zm24.9-176.3l-24.9-14.4 24.9 14.4z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_77_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3059.13,
  x2: 118.955,
  y2: -3059.13,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M377.3 390.3l-27.9-16.4c-.7 1.3-1.2 2.8-1.2 4.4v146.8c0 3.1 1.7 6 4.4 7.6l12.5 7.2 12.5 7.2c1.1.7 2.4 1 3.6 1.1V391.5c-1.4-.1-2.7-.5-3.9-1.2z",
  fill: "url(#hero_svg__SVGID_77_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_78_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3059.13,
  x2: 118.955,
  y2: -3059.13,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M386.4 390.3a8.9 8.9 0 01-3.8 1.2v156.6c1.3-.1 2.5-.5 3.6-1.1l24.9-14.4c2.7-1.6 4.4-4.4 4.4-7.6V378.3c0-1.6-.4-3.1-1.2-4.4l-27.9 16.4z",
  fill: "url(#hero_svg__SVGID_78_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_79_",
  gradientUnits: "userSpaceOnUse",
  x1: 107.428,
  y1: -2970.641,
  x2: 107.428,
  y2: -3133.997,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M386.4 390.3a8.9 8.9 0 01-3.8 1.2v156.6c1.3-.1 2.5-.5 3.6-1.1l24.9-14.4c2.7-1.6 4.4-4.4 4.4-7.6V378.3c0-1.6-.4-3.1-1.2-4.4l-27.9 16.4z",
  fill: "url(#hero_svg__SVGID_79_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_80_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3050.321,
  x2: 118.955,
  y2: -3050.321,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.5v156.6h.7V391.6c-.2 0-.4-.1-.7-.1z",
  fill: "url(#hero_svg__SVGID_80_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_81_",
  gradientUnits: "userSpaceOnUse",
  x1: 381.479,
  y1: 549.515,
  x2: 381.479,
  y2: 391.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.5v156.6h.7V391.6c-.2 0-.4-.1-.7-.1z",
  fill: "url(#hero_svg__SVGID_81_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_82_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3050.321,
  x2: 118.955,
  y2: -3050.321,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.6v156.6h.7V391.5c-.2 0-.4.1-.7.1z",
  fill: "url(#hero_svg__SVGID_82_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_83_",
  gradientUnits: "userSpaceOnUse",
  x1: 90.609,
  y1: -2970.641,
  x2: 90.609,
  y2: -3133.997,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.6v156.6h.7V391.5c-.2 0-.4.1-.7.1z",
  fill: "url(#hero_svg__SVGID_83_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_84_",
  gradientUnits: "userSpaceOnUse",
  x1: 382.211,
  y1: 549.515,
  x2: 382.211,
  y2: 391.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.6v156.6h.7V391.5c-.2 0-.4.1-.7.1z",
  fill: "url(#hero_svg__SVGID_84_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_85_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3146.814,
  x2: 118.955,
  y2: -3146.814,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.5v-.2h.7l32.4-17.4c-.8-1.3-1.8-2.4-3.2-3.2l-24.9-14.4c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c1.4.7 2.7 1.1 4 1.2z",
  fill: "url(#hero_svg__SVGID_85_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_86_",
  gradientUnits: "userSpaceOnUse",
  x1: 381.832,
  y1: 354.493,
  x2: 381.832,
  y2: 421.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.5v-.2h.7l32.4-17.4c-.8-1.3-1.8-2.4-3.2-3.2l-24.9-14.4c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c1.4.7 2.7 1.1 4 1.2z",
  fill: "url(#hero_svg__SVGID_86_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_87_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3137.459,
  x2: 118.955,
  y2: -3137.459,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_87_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_88_",
  gradientUnits: "userSpaceOnUse",
  x1: 106.48,
  y1: -2970.641,
  x2: 106.48,
  y2: -3133.997,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_88_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_89_",
  gradientUnits: "userSpaceOnUse",
  x1: 398.082,
  y1: 354.493,
  x2: 398.082,
  y2: 421.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_89_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_90_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3128.723,
  x2: 118.955,
  y2: -3128.723,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_90_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_91_",
  gradientUnits: "userSpaceOnUse",
  x1: 381.479,
  y1: 549.515,
  x2: 381.479,
  y2: 391.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_91_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_92_",
  gradientUnits: "userSpaceOnUse",
  x1: 381.479,
  y1: 354.493,
  x2: 381.479,
  y2: 421.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.1 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_92_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_93_",
  gradientUnits: "userSpaceOnUse",
  x1: 56.606,
  y1: -3128.723,
  x2: 118.955,
  y2: -3128.723,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_93_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_94_",
  gradientUnits: "userSpaceOnUse",
  x1: 90.609,
  y1: -2970.641,
  x2: 90.609,
  y2: -3133.997,
  gradientTransform: "translate(291.602 3520.155)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_94_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_95_",
  gradientUnits: "userSpaceOnUse",
  x1: 382.211,
  y1: 549.515,
  x2: 382.211,
  y2: 391.313
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_95_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_96_",
  gradientUnits: "userSpaceOnUse",
  x1: 382.211,
  y1: 354.493,
  x2: 382.211,
  y2: 421.493
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.3v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_96_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_97_",
  gradientUnits: "userSpaceOnUse",
  x1: 347.955,
  y1: 382.053,
  x2: 415.736,
  y2: 382.053
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.8 391.6c-2.2 0-4.3-.6-6.2-1.7L348 373.7l.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.3c-1.9 1.1-4.1 1.6-6.3 1.6z",
  fill: "url(#hero_svg__SVGID_97_)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_98_",
  gradientUnits: "userSpaceOnUse",
  x1: 347.769,
  y1: 425.577,
  x2: 415.55,
  y2: 425.577
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.7 435.2c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.1-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_98_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_99_",
  gradientUnits: "userSpaceOnUse",
  x1: 347.769,
  y1: 469.128,
  x2: 415.55,
  y2: 469.128
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.7 478.7c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.2-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_99_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_100_",
  gradientUnits: "userSpaceOnUse",
  x1: 347.769,
  y1: 508.765,
  x2: 415.55,
  y2: 508.765
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M381.7 518.4c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.1-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_100_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_101_",
  gradientUnits: "userSpaceOnUse",
  x1: 321.921,
  y1: 310.202,
  x2: 294.464,
  y2: 255.973
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_101_)",
  d: "M323.5 310.2v-80.1l-33.7 19.5V330z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_102_",
  gradientUnits: "userSpaceOnUse",
  x1: 321.007,
  y1: 303.998,
  x2: 357.56,
  y2: 228.966
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_102_)",
  d: "M323.5 310.2V198.9l33.6 19.4V330z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st37",
  d: "M327.8 311.8l12.5 7.2zM319.1 581l-12.4-7.2zm0-269.2l-12.4 7.2 12.4-7.2zm8.7 269.2l12.5-7.2-12.5 7.2z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_103_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 455.719,
  x2: 357.108,
  y2: 455.719
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M318.9 345.7L291 329.4c-.7 1.3-1.2 2.8-1.2 4.4V559c0 3.1 1.7 6 4.4 7.6l12.5 7.2 12.5 7.2c1.1.7 2.4 1 3.6 1.1V346.9c-1.4-.1-2.7-.5-3.9-1.2z",
  fill: "url(#hero_svg__SVGID_103_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_104_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 455.719,
  x2: 357.108,
  y2: 455.719
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M328 345.7a8.9 8.9 0 01-3.8 1.2v235.2c1.3-.1 2.5-.5 3.6-1.1l12.5-7.2 12.5-7.2c2.7-1.6 4.4-4.4 4.4-7.6V333.7c0-1.6-.4-3.1-1.2-4.4l-28 16.4z",
  fill: "url(#hero_svg__SVGID_104_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_105_",
  gradientUnits: "userSpaceOnUse",
  x1: 340.655,
  y1: 579.993,
  x2: 340.655,
  y2: 337.327
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M328 345.7a8.9 8.9 0 01-3.8 1.2v235.2c1.3-.1 2.5-.5 3.6-1.1l12.5-7.2 12.5-7.2c2.7-1.6 4.4-4.4 4.4-7.6V333.7c0-1.6-.4-3.1-1.2-4.4l-28 16.4z",
  fill: "url(#hero_svg__SVGID_105_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_106_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 464.527,
  x2: 357.108,
  y2: 464.527
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.9v235.2h.7V347c-.2 0-.4-.1-.7-.1z",
  fill: "url(#hero_svg__SVGID_106_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_107_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.105,
  y1: 583.478,
  x2: 323.105,
  y2: 346.736
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.9v235.2h.7V347c-.2 0-.4-.1-.7-.1z",
  fill: "url(#hero_svg__SVGID_107_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_108_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 464.527,
  x2: 357.108,
  y2: 464.527
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 347v235.2h.7V346.9c-.2 0-.5.1-.7.1z",
  fill: "url(#hero_svg__SVGID_108_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_109_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.836,
  y1: 579.993,
  x2: 323.836,
  y2: 337.327
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 347v235.2h.7V346.9c-.2 0-.5.1-.7.1z",
  fill: "url(#hero_svg__SVGID_109_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_110_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.836,
  y1: 583.478,
  x2: 323.836,
  y2: 346.736
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 347v235.2h.7V346.9c-.2 0-.5.1-.7.1z",
  fill: "url(#hero_svg__SVGID_110_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_111_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 328.764,
  x2: 357.108,
  y2: 328.764
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.9v-.2h.7l32.4-17.4c-.8-1.3-1.8-2.4-3.2-3.2l-12.5-7.2-12.5-7.2c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c1.5.7 2.8 1.1 4.1 1.2z",
  fill: "url(#hero_svg__SVGID_111_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_112_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.457,
  y1: 309.993,
  x2: 323.457,
  y2: 374
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.9v-.2h.7l32.4-17.4c-.8-1.3-1.8-2.4-3.2-3.2l-12.5-7.2-12.5-7.2c-2.7-1.6-6-1.6-8.7 0l-12.5 7.2-12.5 7.2c-1.4.8-2.4 1.9-3.2 3.2l27.9 16.4c1.5.7 2.8 1.1 4.1 1.2z",
  fill: "url(#hero_svg__SVGID_112_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_113_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 338.12,
  x2: 357.108,
  y2: 338.12
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_113_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_114_",
  gradientUnits: "userSpaceOnUse",
  x1: 339.707,
  y1: 579.993,
  x2: 339.707,
  y2: 337.327
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_114_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_115_",
  gradientUnits: "userSpaceOnUse",
  x1: 339.707,
  y1: 309.993,
  x2: 339.707,
  y2: 374
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7h.7v.2c1.3-.1 2.6-.5 3.8-1.2l27.9-16.4-32.4 17.4z",
  fill: "url(#hero_svg__SVGID_115_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_116_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 346.855,
  x2: 357.108,
  y2: 346.855
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_116_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_117_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.105,
  y1: 583.478,
  x2: 323.105,
  y2: 346.736
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_117_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_118_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.105,
  y1: 309.993,
  x2: 323.105,
  y2: 374
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M322.7 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_118_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_119_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.833,
  y1: 346.855,
  x2: 357.108,
  y2: 346.855
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_119_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_120_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.836,
  y1: 579.993,
  x2: 323.836,
  y2: 337.327
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_120_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_121_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.836,
  y1: 583.478,
  x2: 323.836,
  y2: 346.736
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_121_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_122_",
  gradientUnits: "userSpaceOnUse",
  x1: 323.836,
  y1: 309.993,
  x2: 323.836,
  y2: 374
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#006b6b"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.131,
  stopColor: "#097671"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.358,
  stopColor: "#209281"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.654,
  stopColor: "#46c09c"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf"
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 346.7v.2h.7v-.2h-.7z",
  fill: "url(#hero_svg__SVGID_122_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_123_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.58,
  y1: 337.476,
  x2: 357.361,
  y2: 337.476
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#7affbf"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 347.1c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.1-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_123_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_124_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.58,
  y1: 385.027,
  x2: 357.361,
  y2: 385.027
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 394.6c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.2-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_124_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_125_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.58,
  y1: 432.577,
  x2: 357.361,
  y2: 432.577
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 442.2c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.1-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_125_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_126_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.58,
  y1: 480.128,
  x2: 357.361,
  y2: 480.128
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 489.7c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.2-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_126_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_127_",
  gradientUnits: "userSpaceOnUse",
  x1: 289.58,
  y1: 527.678,
  x2: 357.361,
  y2: 527.678
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M323.5 537.3c-2.2 0-4.3-.6-6.2-1.7l-27.7-16.2.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.1-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_127_)"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_128_",
  gradientUnits: "userSpaceOnUse",
  x1: 406.404,
  y1: 465.324,
  x2: 474.185,
  y2: 465.324
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.667,
  stopColor: "#7affbf",
  stopOpacity: 0.5
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M440.3 474.9c-2.2 0-4.3-.6-6.2-1.7L406.4 457l.7-1.3 27.7 16.2c3.4 2 7.6 2 11 0l27.7-16.2.7 1.3-27.7 16.2c-1.9 1.2-4.1 1.7-6.2 1.7z",
  fill: "url(#hero_svg__SVGID_128_)"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M501.9 438.7H500V417l-62.3-35.5v-14.1l-56.5-32.5V313l-58.4-34.3 1-1.6 59.2 34.8v21.9l56.6 32.5v14.1l62.3 35.5z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 382.2,
  cy: 311.8,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 323.8,
  cy: 278.9,
  r: 3.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M88.1 104.7c1.2-15.6 31.6-9 36.2-10.8 6.5-2.4 9.4-19.2 11.6-26.8 2.3-7.6 7.6-15.8 8.2-19.8 3.8 6.6 3 13 3 13s4.4-5.5 5.9-8.7c2.1 6.3 1.9 9.9 1.9 9.9s-.9 1.4 1-4.7c14.3-1.7 2 19.8-5.4 18.5-2.7 4.3-4.4 24.3-12.5 31-10.5 8.9-51.2 15.4-49.9-1.6z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 382.2,
  cy: 335.2,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 438.4,
  cy: 365.9,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 438.4,
  cy: 380.8,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 501.1,
  cy: 416.9,
  r: 3.2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 501.1,
  cy: 439.2,
  r: 3.2
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M348.1 544.2c0 2.1-.9 4.6-2.5 6.9-.7 1.1-1.6 2.1-2.5 2.9v1.7c0 1.2-.9 2.6-2.1 3.3-1.2.7-2.1.4-2.1-.8v-1.7c-1.8.5-3.1.3-4-.7-.6-.6-.2-2.1.8-3.3 1-1.2 2.2-1.6 2.8-1 .5.5 1.1.6 2 .2.9-.4 1.7-1.1 2.3-2.1.7-1 1-1.9 1-2.8 0-.8-.4-1.4-1.1-1.5l-5.4-1.1c-1.6-.3-2.5-1.6-2.5-3.6s.8-4.4 2.4-6.7c.7-1.1 1.5-2 2.4-2.8v-1.7c0-1.2.9-2.6 2.1-3.3s2.1-.4 2.1.8v1.7c1.6-.5 3-.3 3.8.7.6.6.3 2-.7 3.3-1 1.2-2.2 1.6-2.8 1-.4-.5-1-.5-1.8-.1s-1.5 1-2.2 2c-.6 1-.9 1.8-.9 2.6s.3 1.3.9 1.4l5.4 1.1c1.6.3 2.6 1.6 2.6 3.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M404.6 518.1c0 1.6-.7 3.4-1.8 5.1-.5.8-1.2 1.5-1.8 2.2v1.2c0 .9-.7 2-1.5 2.5-.9.5-1.5.3-1.5-.6v-1.2c-1.3.4-2.3.2-3-.5-.4-.5-.2-1.5.6-2.5.7-.9 1.7-1.2 2.1-.7.4.4.8.4 1.5.1.7-.3 1.2-.8 1.7-1.5s.8-1.4.8-2.1c0-.6-.3-1-.8-1.1l-4-.8c-1.2-.2-1.9-1.2-1.9-2.7 0-1.5.6-3.3 1.8-5 .5-.8 1.1-1.5 1.8-2.1v-1.2c0-.9.7-2 1.5-2.5.9-.5 1.5-.3 1.5.6v1.3c1.2-.4 2.2-.2 2.8.5.5.4.2 1.5-.5 2.4-.7.9-1.6 1.2-2.1.7-.3-.4-.8-.4-1.4-.1-.6.3-1.2.7-1.6 1.5-.5.7-.7 1.4-.7 2 0 .6.2.9.7 1.1l4 .8c1.1.1 1.8 1.1 1.8 2.6z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M462.1 488.9c0 1.1-.5 2.5-1.3 3.7-.4.6-.9 1.1-1.3 1.6v.9c0 .6-.5 1.4-1.1 1.8-.6.4-1.1.2-1.1-.4v-.9c-1 .3-1.7.2-2.2-.4-.3-.3-.1-1.1.4-1.8.5-.6 1.2-.9 1.5-.5.3.3.6.3 1.1.1.5-.2.9-.6 1.3-1.1.4-.5.6-1 .6-1.5 0-.4-.2-.8-.6-.8l-2.9-.6c-.9-.1-1.4-.9-1.4-2s.4-2.4 1.3-3.6c.4-.6.8-1.1 1.3-1.5v-.9c0-.6.5-1.4 1.1-1.8.6-.4 1.1-.2 1.1.4v.9c.9-.3 1.6-.2 2.1.4.3.3.1 1.1-.4 1.8-.5.6-1.2.9-1.5.5-.2-.3-.6-.3-1-.1-.4.2-.8.5-1.2 1.1-.3.5-.5 1-.5 1.4 0 .4.2.7.5.8l2.9.6c.7.1 1.2.8 1.3 1.9z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M522 461.2c0 .8-.3 1.7-.9 2.5-.3.4-.6.8-.9 1.1v.6c0 .4-.3 1-.8 1.2-.4.3-.8.1-.8-.3v-.6c-.7.2-1.1.1-1.5-.3-.2-.2-.1-.8.3-1.2.4-.4.8-.6 1-.4.2.2.4.2.7.1.3-.2.6-.4.9-.8.3-.4.4-.7.4-1 0-.3-.1-.5-.4-.5l-2-.4c-.6-.1-.9-.6-.9-1.3 0-.7.3-1.6.9-2.5.3-.4.6-.7.9-1v-.6c0-.4.3-1 .8-1.2.4-.3.8-.1.8.3v.6c.6-.2 1.1-.1 1.4.3.2.2.1.8-.3 1.2-.4.4-.8.6-1 .4-.1-.2-.4-.2-.7-.1s-.6.4-.8.7c-.2.4-.4.7-.3 1 0 .3.1.5.4.5l2 .4c.4.1.8.5.8 1.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M500.4 402.8c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.4-.1-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.3-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.3-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.3-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.4-.1-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.3-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.4-.8-.8zm0-6.3c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8s-.8-.3-.8-.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M512.8 315.6h-23.3c-1.3 0-2.4-.7-3-1.8s-.6-2.4.1-3.4l11.6-18.2c.6-1 1.7-1.6 2.9-1.6s2.2.6 2.9 1.6l11.6 18.2c.7 1.1.7 2.3.1 3.4s-1.6 1.8-2.9 1.8zm-25.1-4.6c-.4.7-.5 1.5-.1 2.3.4.7 1.1 1.1 1.9 1.1h23.3c.8 0 1.5-.4 1.9-1.1.4-.7.4-1.6-.1-2.3L503 292.8c-.4-.6-1.1-1-1.9-1-.8 0-1.5.4-1.9 1L487.7 311z",
  fill: "#7affbf"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M502.8 298.3v.4l-.9 7.7h-1.6l-.9-7.7v-.4h3.4zm-3.1 13.2v-3h3v3h-3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M501 282.4c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6 0-.2.1-.4.2-.5.3-.3.8-.3 1.1 0 .1.1.2.4.2.5 0 .2-.1.4-.2.6-.2.1-.4.2-.6.2zm-.8-7.9c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.3-.8-.8zm0-7c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5-.1-.8-.4-.8-.8zm.8-6.3c-.2 0-.4-.1-.5-.2-.1-.1-.2-.3-.2-.6s.1-.4.2-.5c.2-.2.6-.3.9-.2.1 0 .2.1.2.2.1.1.2.3.2.5s-.1.4-.2.6c-.2.1-.4.2-.6.2zm-5.9-3.3c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2.1-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1.1-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2-.1-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2-.1-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.1-3.1c-.2 0-.4-.1-.6-.2-.1-.1-.2-.4-.2-.6 0-.2.1-.4.2-.5.1-.1.2-.1.2-.2.3-.1.6 0 .9.2.1.1.2.3.2.5s-.1.4-.2.6c-.1.1-.3.2-.5.2zm-35 20.2c-.2-.4-.1-.9.3-1.1.4-.2.8-.1 1.1.3.2.4.1.9-.3 1.1-.1.1-.3.1-.4.1-.2 0-.5-.2-.7-.4zm5.8-3.4c-.2-.4-.1-.8.3-1.1.4-.2.9-.1 1.1.3.2.4.1.9-.3 1.1-.1.1-.3.1-.4.1-.3 0-.6-.2-.7-.4zm5.7-3.5c-.2-.4-.1-.9.3-1.1.4-.2.9-.1 1.1.3.2.4.1.8-.3 1.1-.1.1-.3.1-.4.1-.3 0-.6-.1-.7-.4zm5.7-3.4c-.2-.4-.1-.9.3-1.1.4-.2.9-.1 1.1.3.2.4.1.9-.3 1.1-.1.1-.3.1-.4.1-.3 0-.6-.1-.7-.4zm5.7-3.4c-.2-.4-.1-.8.3-1.1.4-.2.9-.1 1.1.3.2.4.1.9-.3 1.1-.1.1-.3.1-.4.1-.3 0-.5-.2-.7-.4zm5.7-3.4c-.2-.4-.1-.9.3-1.1.4-.2.9-.1 1.1.3.2.4.1.9-.3 1.1-.1.1-.3.1-.4.1-.3-.1-.5-.2-.7-.4zm-33.6 20.9c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.2-.4-.2-.6 0-.2.1-.4.2-.5.3-.3.8-.3 1.1 0 .1.1.2.3.2.5s-.1.4-.2.6c-.2.2-.4.3-.6.3z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M282.3 520.5c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.2-.2-.1-.1-.1-.2-.2-.2 0-.1-.1-.2-.1-.3 0-.2.1-.4.2-.5.1-.1.2-.1.2-.2.2-.1.4-.1.6 0 .1 0 .2.1.3.2.1.1.2.3.2.5s-.1.4-.2.6c-.1.1-.2.1-.3.2h-.2zm-5.8-3.3c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.3-.4.4-.7.4-.1.1-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.3-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2-.1-.4-.1zm-5.4-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2.1-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5.4-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3-.1-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.2 0-.3 0-.4-.1zm-5.5-3.2c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.2.2-.4.4-.7.4-.1 0-.3 0-.4-.1zm-5.5-3.1c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.3-.1-.4-.1zM134 435c-.4-.2-.5-.7-.3-1.1.2-.4.7-.5 1.1-.3.4.2.5.7.3 1.1-.1.2-.4.4-.7.4-.1 0-.2 0-.4-.1zm-5-3c-.1 0-.2 0-.3-.1-.1 0-.2-.1-.3-.2-.1-.2-.2-.4-.2-.6 0-.1 0-.2.1-.3 0-.1.1-.2.2-.3.1-.1.2-.1.3-.2.2-.1.4-.1.6 0 .1 0 .2.1.2.2.1.1.1.2.2.3 0 .1.1.2.1.3 0 .2-.1.4-.2.6-.3.2-.5.3-.7.3zm-.8-7c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5-.1-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5-.1-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5-.1-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.4-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5-.1-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.3.8.8c0 .4-.4.8-.8.8-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5-.1-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.4-.8-.8zm0-6.2c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5 0-.8-.3-.8-.8zm0-6.1c0-.4.4-.8.8-.8s.8.4.8.8-.4.8-.8.8c-.5-.1-.8-.4-.8-.8zm.8-5.4c-.2 0-.4-.1-.6-.2-.1-.2-.2-.4-.2-.6 0-.2.1-.4.2-.6.2-.2.6-.3.9-.2.1 0 .2.1.2.2.1.2.2.4.2.6 0 .1 0 .2-.1.3 0 .1-.1.2-.2.3 0 .1-.2.2-.4.2zm4.4-3.9c-.2-.4-.1-.8.2-1.1.4-.2.9-.2 1.1.2.2.4.2.9-.2 1.1-.1.1-.3.1-.4.1-.3.1-.5-.1-.7-.3zm5.2-3.5c-.2-.4-.2-.8.2-1.1.4-.2.9-.1 1.1.2.2.4.2.9-.2 1.1-.1.1-.3.1-.4.1-.3 0-.6-.1-.7-.3zm5.1-3.5c-.2-.4-.1-.8.2-1.1.4-.2.8-.1 1.1.2.2.4.2.8-.2 1.1-.1.1-.3.1-.4.1-.3 0-.5-.1-.7-.3zm5.1-3.6c-.2-.4-.1-.8.2-1.1.4-.2.8-.2 1.1.2.2.4.2.8-.2 1.1-.1.1-.3.1-.4.1-.3.1-.5 0-.7-.3zm5.8-3.1c-.2 0-.4-.1-.5-.2-.1-.1-.2-.4-.2-.5 0-.2.1-.4.2-.6.2-.2.6-.3.9-.2.1 0 .2.1.2.2.1.1.2.3.2.6 0 .2-.1.4-.2.5l-.2.2c-.1.1-.3 0-.4 0z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M160.6 228.7v-24.2c0-1.6 1.1-3.4 2.7-4.3l17.6-10.3c1.6-.9 2.7-.5 2.7 1.1s-1.1 3.4-2.7 4.3L166 204v15.2c3-3.3 6.1-5.5 9.4-6.6 5.8-1.8 9.6 1 9.6 6.9v9.3c0 5.8-3.8 13.1-9.6 18-5.6 4.8-11.6 5.8-14.5 2.4-.7-.9-.3-2.8 1-4.3 1.3-1.4 3-2 3.7-1.2 1.7 2 5.1 1.4 8.4-1.4 3.3-2.9 5.5-7 5.5-10.4v-9.3c0-3.4-2.2-5-5.5-4s-6.7 4.4-8.4 8.4c-.6 1.4-1.8 2.6-3 3-1.2.5-2-.1-2-1.3zm34-5.5v-28.8c0-7.1 5.8-16.2 12.9-20.4 7-4.1 12.9-1.7 12.9 5.4v28.8c0 7.1-5.8 16.3-12.9 20.4-7.2 4.2-12.9 1.8-12.9-5.4zm5.4-31.9v28.8c0 4.1 3.3 5.5 7.5 3.1 4.1-2.4 7.5-7.6 7.5-11.8v-28.8c0-4.1-3.4-5.5-7.5-3.1-4.2 2.4-7.5 7.7-7.5 11.8zm29.8 11.4v-28.8c0-7.1 5.8-16.2 12.9-20.4 7-4.1 12.9-1.7 12.9 5.4v28.8c0 7.1-5.8 16.3-12.9 20.4-7.1 4.1-12.9 1.7-12.9-5.4zm5.4-31.9v28.8c0 4.1 3.3 5.5 7.5 3.1 4.1-2.4 7.5-7.6 7.5-11.8v-28.8c0-4.1-3.4-5.5-7.5-3.1-4.2 2.4-7.5 7.7-7.5 11.8z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_129_",
  gradientUnits: "userSpaceOnUse",
  x1: 162.332,
  y1: 97.193,
  x2: 254.892,
  y2: 12.663,
  gradientTransform: "matrix(1 -.00325 .00325 1 -4.88 4.702)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M192.6 43c-21.7 8.3-34.3 29.2-38.8 53.1l14.5 8.3L241.5 56s-6.3-5.6-9.1-7.4c-7.6-4.9-21.2-12.7-39.8-5.6z",
  fill: "url(#hero_svg__SVGID_129_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_130_",
  gradientUnits: "userSpaceOnUse",
  x1: 166.081,
  y1: 88.018,
  x2: 349.748,
  y2: -14.649,
  gradientTransform: "matrix(1 -.00325 .00325 1 -4.88 4.702)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M207.1 51.2c-18.7 7-33.6 24.1-38.8 53.1l77.5-44.7c-7.6-8.9-20.7-15.1-38.7-8.4z",
  fill: "url(#hero_svg__SVGID_130_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_131_",
  gradientUnits: "userSpaceOnUse",
  x1: 170.807,
  y1: 107.29,
  x2: 232.651,
  y2: 45.447
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#fff",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.936,
  stopColor: "#fff",
  stopOpacity: 0.042
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.969,
  stopColor: "#fff",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M168.9 104.4l-1.2-.2c4.8-26.8 18.7-45.8 39.2-53.5 21.9-8.3 34.9 3.2 39.4 8.5l-.9.8c-13.1-15.4-31-10.9-38.1-8.2-14.2 5.3-32.3 18.8-38.4 52.6z",
  fill: "url(#hero_svg__SVGID_131_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_132_",
  gradientUnits: "userSpaceOnUse",
  x1: 74.079,
  y1: 111.732,
  x2: 222.904,
  y2: 39.471,
  gradientTransform: "matrix(1 -.00325 .00325 1 -4.88 4.702)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  d: "M217.5 45.3l-4.6-2c-18.5-1.1-38.3 12.5-44.5 27.4l6 2.7c7.3-15.7 25.6-27.7 43.1-28.1z",
  fill: "url(#hero_svg__SVGID_132_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st146",
  d: "M217.5 45.3l-4.6-2-.1 2.4c1.5-.2 3.1-.3 4.7-.4z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st146",
  d: "M156.5 58.5l-2.1 4.6c0 .1-.1.2-.2.3l20.3 9.4c1-1.9 1.9-3.4 2.9-4.9l-20.8-9.7c0 .1 0 .2-.1.3z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st146",
  d: "M131.3 46.5l25.3 11.7c.5-1.4-.1-3-1.5-3.6L129 42.5c-1.5-.7-3.2 0-3.9 1.4l-2.1 4.6c-.7 1.5 0 3.2 1.4 3.9l26.1 12.1c1.4.6 3 .1 3.7-1.2L129 51.6l2.3-5.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st146",
  d: "M156.5 58.5c0-.1.1-.2.1-.3l-25.3-11.7-2.4 5.1 25.3 11.7c.1-.1.1-.2.2-.3l2.1-4.5z"
}))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_133_",
  gradientUnits: "userSpaceOnUse",
  x1: -121.739,
  y1: 385.76,
  x2: -121.739,
  y2: 9.575,
  gradientTransform: "matrix(-1 0 0 1 77.497 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.965,
  stopColor: "#fff",
  stopOpacity: 0.162
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  d: "M67.7 385.8h-1.2V168.5c0-3.6 1.9-6.9 5-8.7L331.4 9.6l.6 1L72.1 160.9c-2.7 1.6-4.4 4.5-4.4 7.6v217.3z",
  fill: "url(#hero_svg__SVGID_133_)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_134_",
  gradientUnits: "userSpaceOnUse",
  x1: 55.303,
  y1: 140.526,
  x2: 84.408,
  y2: 143.68
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#00665f",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#00665f"
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_134_)",
  d: "M87.5 150.7l-24.9-2 21.6-12.5z"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M94.5 123.2l4.3 23.7 15.3 1.4s-3.9 17.2 1.7 23c5.6 5.7 10.3 3 16.3 5.5 1.3-2.9-3.2-6.5-3.2-6.5s3.1-.3 6.9 1.3c1.3-3.3-3.1-6.2-3.1-6.2s2.3-.4 5.3.4c1.2-5.1-9.7-6-9.7-6s15.7-26.5.2-34.5c-13.4-7-34-2.1-34-2.1z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_135_",
  gradientUnits: "userSpaceOnUse",
  x1: -1035.231,
  y1: 173.484,
  x2: -1035.231,
  y2: 194.452,
  gradientTransform: "scale(-1 1) rotate(-46.645 -635.14 -892.973)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M94.5 123.2l4.3 23.7 15.3 1.4s-3.9 17.2 1.7 23c5.6 5.7 10.3 3 16.3 5.5 1.3-2.9-3.2-6.5-3.2-6.5s3.1-.3 6.9 1.3c1.3-3.3-3.1-6.2-3.1-6.2s2.3-.4 5.3.4c1.2-5.1-9.7-6-9.7-6s15.7-26.5.2-34.5c-13.4-7-34-2.1-34-2.1z",
  fill: "url(#hero_svg__SVGID_135_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M109.9 134.1c6.3-9.6 1.7-24.8.1-33.6-3-16.1-31.3-18.3-31.4-10.5-.2 18.2-10.1 21.9-12.3 35.1-1.8 10.6 5.3 17.7 12.6 20.7 10.3 4.3 24.2-1.5 31-11.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_136_",
  gradientUnits: "userSpaceOnUse",
  x1: 2496.956,
  y1: 123.389,
  x2: 2513.889,
  y2: 118.718,
  gradientTransform: "matrix(-1 0 0 1 2609.426 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.9 134.1c6.3-9.6 1.7-24.8.1-33.6-3-16.1-31.3-18.3-31.4-10.5-.2 18.2-8.6 21.5-9 34.9-.4 12.6 2.1 17.9 9.3 20.9 10.3 4.3 24.2-1.5 31-11.7z",
  fill: "url(#hero_svg__SVGID_136_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M113.7 59.4c-6.1-7.3-24.7-10-37.4 4.3-4.1 4.6 7.3 3.8.1 14.2-10.4 15.2 26.5 28.7 36 26.5 2.2-.5 12.3-15.9 9.3-21.3 2.6-3.5 2.7-6.3 2-8.8-.7-3-7.3-11.7-10-14.9z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M84 65.3c.9-10.9-15.1-3.5-22.9-17.5-2.3 3.5-3.8 9-.9 14.7 3.2 6.3 1.5 11.1 7.1 15.6 5.1 4.2 12.4 2.2 14.6-.3 3.8-4.3 1.8-8.3 2.1-12.5zm25.1 4.9c-3.5-10.3 9.6-4.7 11.2-18.6 2.5 3.1 5 8.3 4.5 14-.5 6.3 1.9 10.7-.8 15.4-2.4 4.4-8 3.2-10.3.9-3.5-3.7-3.2-7.7-4.6-11.7z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_137_",
  gradientUnits: "userSpaceOnUse",
  x1: -963.754,
  y1: 143.041,
  x2: -970.537,
  y2: 158.955,
  gradientTransform: "scale(-1 1) rotate(-46.645 -635.14 -892.973)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M113.7 59.4c-6.1-7.3-24.7-10-37.4 4.3-4.1 4.6 7.3 3.8.1 14.2-10.4 15.2 26.5 28.7 36 26.5 2.2-.5 12.3-15.9 9.3-21.3 2.6-3.5 2.7-6.3 2-8.8-.7-3-7.3-11.7-10-14.9z",
  fill: "url(#hero_svg__SVGID_137_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st49",
  d: "M124.5 91.9c1.1-.6 2.7-1.6 2.6-2.8l-.1-.1h-.1c-.8.9-2.2 1.2-3.5 1.3-.1 0-.1 0-.1.1l1.1 1.4c0 .1 0 .1.1.1zm-2.6 1.1c.6-.2 1.2-.4 1.7-.7.1 0 .1-.1 0-.2l-1.2-1.5s-.1-.1-.1 0l-.7 2.2c0 .2.1.3.3.2zm-1.1 0l.7-2.3c0-.1-.1-.3-.2-.3h-.6c-.5 0-1-.1-1.6-.2h-.1c-.2 0-.3.1-.3.2v.2l2 2.6c-.1-.2 0-.2.1-.2zm-5.3 1.1c1.4-.1 2.7-.2 4.1-.5.2 0 .3-.2.3-.4v-.1c-.6-.8-2-2.5-2.4-3 0 0-.1-.1-.1 0l-2.2 3.5c-.1.2 0 .3.2.4 0 0 0 .1.1.1zm-1.4-.3l2.3-3.8c.1-.2 0-.3-.2-.4h-.1c-.5-.1-1.1-.2-1.6-.3-.9-.2-1.8-.3-2.8-.5-.2 0-.3.1-.3.2v.1l2.6 4.7c-.1.1 0 .1.1 0 0 .1 0 0 0 0zm-5.3.2c1.4.1 2.6.1 3.8.1.2 0 .4-.1.4-.3v-.1l-2.2-4.1s-.1-.1-.1 0h-.1l-2.1 3.9c-.1.2 0 .3.2.4 0 .1 0 .1.1.1zm-1.4-.5l.1.1h.1L110 89c.1-.2 0-.3-.2-.4h-.1c-.6-.1-1.1-.1-1.8-.2-.6-.1-1.2-.1-1.8-.1-.2 0-.4.1-.4.3v.1l1.7 4.8zm-5.1-.3c1.2.2 2.4.4 3.8.6.2 0 .4-.1.4-.3v-.1l-1.4-4.3-.1-.1h-.1l-2.9 3.6c-.1.1-.1.3.1.4.1.2.2.2.2.2zm-1.2-.5l3.4-4.2c.1-.1 0-.3-.1-.3h-4.8c-.2 0-.3.1-.3.2v.1l1.6 4.2h.2zm-5.5-1.3c1.3.5 2.6.9 3.9 1.2.2.1.4 0 .5-.2v-.2l-1.5-3.8-.1-.1c-.5.4-2.1 1.9-2.9 2.6-.2.1-.2.3.1.5-.1 0 0 0 0 0zm-1.4-3.2l.3 2.4.1.1h.1l2.5-2.2c.1-.1.1-.2 0-.3-.1 0-.1-.1-.2-.1h-.1c-.6 0-1.2-.1-1.7-.1-.2 0-.4 0-.5-.1-.3 0-.4.1-.5.3 0-.1 0-.1 0 0zm-2.3 1.3c.5.4 1 .7 1.6 1 .1.1.2 0 .2-.1l-.2-2.3-.1-.1h-.1l-1.4 1.3c-.1.1-.1.1 0 .2zm-1.4-1.1c.2.2.4.3.6.5h.1l1.3-1.2v-.1c-.9-.2-1.6-.5-2.1-.8-.5-.3-.9-.7-1.1-1.1 0 0-.1-.1-.1 0h-.1c0 .1-.1.3 0 .4-.1.6.4 1.4 1.4 2.3z",
  id: "hero_svg__Teeth_3_"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_138_",
  gradientUnits: "userSpaceOnUse",
  x1: -942.888,
  y1: 162.527,
  x2: -943.316,
  y2: 178.356,
  gradientTransform: "scale(-1 1) rotate(-46.645 -635.14 -892.973)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M84 65.3c.9-10.9-15.1-3.5-22.9-17.5-2.3 3.5-3.8 9-.9 14.7 3.2 6.3 1.5 11.1 7.1 15.6 5.1 4.2 12.4 2.2 14.6-.3 3.8-4.3 1.8-8.3 2.1-12.5z",
  fill: "url(#hero_svg__SVGID_138_)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_139_",
  gradientUnits: "userSpaceOnUse",
  x1: -974.704,
  y1: 129.033,
  x2: -979.41,
  y2: 141.44,
  gradientTransform: "scale(-1 1) rotate(-46.645 -635.14 -892.973)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M109.1 70.2c-3.5-10.3 9.6-4.7 11.2-18.6 2.5 3.1 5 8.3 4.5 14-.5 6.3 1.9 10.7-.8 15.4-2.4 4.4-8 3.2-10.3.9-3.5-3.7-3.2-7.7-4.6-11.7z",
  fill: "url(#hero_svg__SVGID_139_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M93.1 123.9l-17.7 20 14.3 8.3s-13.6 11.3-12.6 19.3 6.8 9.4 9.6 14.3c4-2.4.8-6.8.8-6.8s3.2 1 6.7 4.8c2.6-2.8 0-6.7 0-6.7s3.8.3 6.9 2.8c1.8-5.6-7.1-9.9-7.1-9.9s28.6-11.5 21.2-27.2c-6.5-13.7-22.1-18.9-22.1-18.9z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_140_",
  gradientUnits: "userSpaceOnUse",
  x1: 2494.204,
  y1: 154.885,
  x2: 2519.257,
  y2: 154.885,
  gradientTransform: "matrix(-1 0 0 1 2609.426 0)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M93.1 123.9l-17.7 20 14.3 8.3s-13.6 11.3-12.6 19.3 6.8 9.4 9.6 14.3c4-2.4.8-6.8.8-6.8s3.2 1 6.7 4.8c2.6-2.8 0-6.7 0-6.7s3.8.3 6.9 2.8c1.8-5.6-7.1-9.9-7.1-9.9s28.6-11.5 21.2-27.2c-6.5-13.7-22.1-18.9-22.1-18.9z",
  fill: "url(#hero_svg__SVGID_140_)"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st140",
  d: "M95.3 105.9c-1.5-14.7 21.8-14.7 29.9-18.9 5.8-3 5.3-21.5 6.1-28.9.8-7.4 4-16.6 13-17.2-3.8 6.4-3.8 9.1-3.8 9.1s6.7-8.2 14.6-6.4c-5 4.1-6.3 9.1-6.3 9.1s6.6-3.2 11-.3c-12 4.4-6.7 14-13.8 14-1.8 4.4-2.2 24.1-8.6 31.7-8.4 9.7-40.5 23.7-42.1 7.8z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_141_",
  gradientUnits: "userSpaceOnUse",
  x1: 143.901,
  y1: 94.796,
  x2: 125.568,
  y2: 76.462
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#7affbf",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#7affbf",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("path", {
  d: "M95.3 105.9c-1.5-14.7 21.8-14.7 29.9-18.9 5.8-3 5.3-21.5 6.1-28.9.8-7.4 4-16.6 13-17.2-3.8 6.4-3.8 9.1-3.8 9.1s6.7-8.2 14.6-6.4c-5 4.1-6.3 9.1-6.3 9.1s6.6-3.2 11-.3c-12 4.4-6.7 14-13.8 14-1.8 4.4-2.2 24.1-8.6 31.7-8.4 9.7-40.5 23.7-42.1 7.8z",
  fill: "url(#hero_svg__SVGID_141_)"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_13_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st156",
  d: "M93.5 72.4c1.8.3 3.7 1.6 5.9 3.1-3.8-1.5-5.6-1.5-5.6-1.5-.2.7-.2 1.5-.2 2.3.1 2.8 1.7 5.6 5.9 6.3 2.6.5 5.2-.5 6.9-2.5 1.4 0 2.5-.3 2.5-.3s-1.5-.8-3.6-2c-5.6-3.2-9-7.3-12.2-7.7-1.9-.2-2.8 2.3-2.8 2.3 1.1-.2 2.1-.2 3.2 0z",
  id: "hero_svg__Brow__x2B__Eyes_13_"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_10_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st157",
  d: "M101.2 77.7c-2.6-1.4-4.2-1.5-4.2-1.5-.1.4-.1.9-.1 1.3.1 1.6 1 3.3 3.5 3.7 1.5.3 3.1-.3 4-1.5 0 0-.6-.6-3.2-2z",
  id: "hero_svg__Brow__x2B__Eyes_10_"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_2_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st156",
  d: "M123 76.7c-1.6-.4-4.1 1.9-7.5 3.1-1.2.4-2.5.7-2.7.8-.2 0 1.1.4 1.8.6.4 1.8 1.5 3 2.8 3.2 2.2.4 3.5-1.4 4.2-3.3.2-.5.3-1.1.4-1.7 0 0-.9-.4-3.1-.1 1.4-.7 2.6-1.2 3.5-1 .6.1 1.1.3 1.6.6-.1 0 0-2-1-2.2z",
  id: "hero_svg__Brow__x2B__Eyes_2_"
})), /*#__PURE__*/React.createElement("g", {
  id: "hero_svg__b_x2B_w_mascot_8_"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st157",
  d: "M117.5 80.7c1.5-.4 2.2-.2 2.2-.2 0 .3-.1.6-.2.8-.3 1-1 1.9-2.2 1.7-.8-.1-1.4-.7-1.6-1.6-.1 0 .3-.3 1.8-.7z",
  id: "hero_svg__Brow__x2B__Eyes_8_"
})))), /*#__PURE__*/React.createElement("g", {
  className: "hero_svg__st4"
}, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M188.7 76.6l-1.7-1.1c9-14.5 25.4-22.1 36-21l-.2 2c-12.6-1.2-27.5 9.5-34.1 20.1z"
}), /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st40",
  d: "M221.7 59.1l1.4-7.1 2.9 4.2zm-30.5 18.4l-6.3-3.6 1.3 5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st158",
  d: "M179.9 90.7c0-1.3 1.2-3.1 2.9-4.1 1.7-1 2.9-.6 2.9.7 0 1.3-1.2 3.1-2.9 4.1s-2.9.7-2.9-.7zm4.6-2.6c0-.8-.7-1.1-1.7-.5-1 .6-1.6 1.6-1.6 2.4 0 .8.7 1.1 1.7.5s1.6-1.6 1.6-2.4zm1.9-3c0-.3.3-.7.6-.9l3.1-1.8c.3-.2.5-.1.5.2s-.2.6-.5.8l-2.5 1.4v1l2.1-1.2c.3-.2.5-.1.5.2 0 .3-.2.6-.5.8l-2.1 1.2v1.3c0 .3-.3.7-.6.9-.3.2-.6.1-.6-.2v-3.7zm4.8-2.7c0-.3.3-.7.6-.9l3.1-1.8c.3-.2.5-.1.5.2s-.2.6-.5.8l-2.5 1.4v1l2.1-1.2c.3-.2.5-.1.5.2 0 .3-.2.6-.5.8l-2.1 1.2v1.3c0 .3-.3.7-.6.9-.3.2-.6.1-.6-.2v-3.7z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "hero_svg__st158",
  d: "M222.5 65.8c0-1.3 1.2-3.1 2.9-4 1.7-1 2.8-.6 2.8.7 0 1.3-1.2 3-2.9 4s-2.8.6-2.8-.7zm4.5-2.5c0-.8-.7-1.1-1.6-.5-.9.5-1.6 1.6-1.6 2.3 0 .8.7 1 1.6.5.9-.5 1.6-1.5 1.6-2.3zm1.9-2.9c0-.3.3-.7.6-.8l.1-.1c.3-.2.5-.1.6-.1l2.3 1.2v-2.3c0-.3.3-.6.6-.8.3-.2.6-.1.6.2v3.6c0 .3-.3.7-.6.8-.3.2-.5.1-.6.1l-2.4-1.3v2.4c0 .3-.3.6-.6.8-.3.2-.6.1-.6-.2v-3.5z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "hero_svg__SVGID_142_",
  gradientUnits: "userSpaceOnUse",
  x1: 153.556,
  y1: 100.175,
  x2: 168.62,
  y2: 100.175
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#fff",
  stopOpacity: 0
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.497,
  stopColor: "#fff"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.965,
  stopColor: "#fff",
  stopOpacity: 0.162
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0.1
})), /*#__PURE__*/React.createElement("path", {
  fill: "url(#hero_svg__SVGID_142_)",
  d: "M168 104.8l-14.4-8.2.6-1.1 14.4 8.3z"
})), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 128.9,
  cy: 431.2,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 128.9,
  cy: 339,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 232.9,
  cy: 491,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 128.9,
  cy: 246.5,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 263.9,
  cy: 169.5,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 303.9,
  cy: 145.5,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 500.9,
  cy: 260.5,
  r: 2
}), /*#__PURE__*/React.createElement("circle", {
  className: "hero_svg__st49",
  cx: 385.9,
  cy: 193.5,
  r: 2
})));

function SvgHero(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "hero_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 645.7 653.4"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/hero.5c9f3847.svg";
export { SvgHero as ReactComponent };